import _ from 'lodash';
import { SectionPresetStructure } from '../../types';
import { SerializedCompStructure } from '@wix/document-services-types';

const parallaxBehaviorName = 'BgParallax';
const zoomOutBehaviorName = 'BgZoomOut';

const removeParallaxBehaviorsRecursively = (
  structure: SerializedCompStructure,
): void => {
  if (structure.behaviors?.items?.includes(parallaxBehaviorName)) {
    delete structure.behaviors;
  }
  structure.components?.forEach((childStructure) => {
    removeParallaxBehaviorsRecursively(childStructure);
  });
};

export const removeParallaxBehaviors = (
  sections: SectionPresetStructure[],
): SectionPresetStructure[] => {
  sections.forEach(({ structure, mobileStructure }) => {
    removeParallaxBehaviorsRecursively(structure);
    removeParallaxBehaviorsRecursively(mobileStructure);
  });
  return sections;
};

const removeZoomOutRecursively = (
  parentStructure: SerializedCompStructure,
): void => {
  if (parentStructure.behaviors?.items?.includes(zoomOutBehaviorName)) {
    delete parentStructure.behaviors;
  }
  parentStructure.components?.forEach((childStructure) => {
    removeZoomOutRecursively(childStructure);
  });
};

const removeZoomOut = (
  rootStructure: SerializedCompStructure,
): SerializedCompStructure => {
  const clonedStructure = _.cloneDeep(rootStructure);
  removeZoomOutRecursively(clonedStructure);
  return clonedStructure;
};

export const replaceZoomOutBehaviors = (
  sections: SectionPresetStructure[],
): SectionPresetStructure[] => {
  return sections.map((section) => {
    return {
      ...section,
      structure: removeZoomOut(section.structure),
      mobileStructure: removeZoomOut(section.mobileStructure),
    };
  });
};
